<template>
  <!-- 实训中心详情 -->
  <div class="courseDetails">
    <gat-head class="courseDetails-head" ref="gatHead"></gat-head>
    <div class="courseDetails-content">
      <div class="courseDetails-bg">
        <!-- <img src="../../assets/images/liveBroadcast-bg.png" alt="" /> -->
      </div>
      <div class="courseDetails-Interface">
        <div class="content-modify-cover">
          <!-- <div class="cover">
            <img
              v-if="modifyCoverObj.imgUrl"
              :src="modifyCoverObj.imgUrl"
              alt=""
            />
            <img v-else src="../../assets/images/upload-bg.png" />
            <div class="modify" v-if="teacherOrStudentState">
              <span class="icon" @click="onUpload()"></span>
              <span class="modify-text">修改封面</span>
            </div>
          </div> -->
          <div class="cover">
            <img
              v-if="modifyCoverObj.imgUrl"
              :src="photoBaseUrl + modifyCoverObj.imgUrl"
              alt=""
            />
            <img v-else src="../../assets/images/upload-bg.png" />
            <div class="avatar-uploader">
              <div
                class="modify"
                v-if="roleCoursePermissions()"
                @click="uploadPictures"
              >
                <span class="icon"></span>
                <span class="modify-text">修改封面</span>
              </div>
            </div>
          </div>
          <div class="cover">
            <el-input
              type="text"
              placeholder="编辑课程标题"
              v-model.trim="modifyCoverObj.curriculumName"
              maxlength="50"
              show-word-limit
              @blur="updateCurriculum"
              v-if="roleCoursePermissions()"
            >
            </el-input>
            <div v-else class="input-text">
              {{ modifyCoverObj.curriculumName }}
            </div>
          </div>
          <div class="cover">
            <el-input
              type="textarea"
              placeholder="编辑课程简介"
              v-model.trim="modifyCoverObj.curriculumContent"
              maxlength="200"
              show-word-limit
              resize="none"
              @blur="updateCurriculum"
              v-if="roleCoursePermissions()"
            >
            </el-input>
            <div v-else class="input-textarea">
              {{ modifyCoverObj.curriculumContent }}
            </div>
          </div>
        </div>

        <!-- <div class="content-teacherInformation">
          <div class="teacherInformation-left">
            <img
              :src="modifyCoverObj.photo ? photoBaseUrl + modifyCoverObj.photo : profile"
              alt=""
            />
          </div>
          <div class="teacherInformation-right">
            <p>
              {{ modifyCoverObj.createUserName}}
              <span>{{ modifyCoverObj.orgsName }}</span>
            </p>
            <div v-if="teacherOrStudentState" class="teacher-resume">
              {{ modifyCoverObj.resume }}
            </div>
            <div v-else class="teacher-textarea">
              {{ modifyCoverObj.resume }}
            </div>
          </div>
        </div> -->

        <!-- 实训目录列表 -->
        <div class="content-list-showCard">
          <!-- <div class="showCard-header" v-if="modifyCoverObj.type == 1 && userRole == 4"> -->
          <div class="showCard-header" v-if="modifyCoverObj.type == 1 && userRole == 4 || modifyCoverObj.type != 1 && userRole == 1 || modifyCoverObj.type != 1 && userRole == 3">
            <div class="showCard-header-nav">
              <span :class="[navSelectName === '实训目录'? 'nav-name-color': '' ]" @click="navSelectName = '实训目录'">实训目录</span>
              <span :class="[navSelectName === '关联租户'? 'nav-name-color': '' ]" @click="navSelectName = '关联租户'" v-if="userRole == 4">关联租户</span>
              <span :class="[navSelectName === '关联用户'? 'nav-name-color': '' ]" @click="navSelectName = '关联用户'" v-else>关联用户</span>
            </div>
            <span class="line"></span>
            <span class="content-length">{{ navSelectName === '实训目录'? trainingCatalogueList.length : tableData.length }}个</span>
          </div>
          <div class="showCard-header" v-else>
            <span class="showCard-header-nav left-nav-border">实训目录</span>
            <span class="line"></span>
            <span class="content-length">{{ trainingCatalogueList.length }}个</span>
          </div>

          <!-- 实训目录 -->
          <div v-if="navSelectName === '实训目录'">
            <div class="showCard-sort">
              <!-- 实训目录排序 -->
              <div class="showCard-sort-name" v-for="(item, index) in sortList" :key="index">
                <!-- <el-divider direction="vertical" v-if="index >= 1"></el-divider> -->
                <span class="span-sort-name" @click="onIconSortName(item.sortType)">{{item.sortName}}</span>
                <span class="span-sort-icon">
                  <i
                    :class="[
                      'el-icon-caret-top',
                      selectIconSort === item.sortType && selectIconSortState === item.sortTop
                        ? 'icon-skyblue'
                        : '',
                    ]"
                    @click.stop="onIconSort(item.sortType, item.sortTop)"
                  ></i>
                  <i
                    :class="[
                      'el-icon-caret-bottom',
                      selectIconSort === item.sortType && selectIconSortState === item.sortBottom
                        ? 'icon-skyblue'
                        : '',
                    ]"
                    @click.stop="onIconSort(item.sortType, item.sortBottom)"
                  ></i>
                </span>
              </div>

              <div class="showCard-sort-right">
                <!-- 实训目录搜索 -->
                <search-box :placeholderName="'请输入实训项目名称'" :buttonShow="false" @onSearchKey="GetPageListByName"></search-box>
                <!-- 添加实训 -->
                <button class="btn-create" v-if="roleCoursePermissions()" @click="activeCreatePopup"></button>
              </div>
            </div>

            <div
              :id="item.trainingId"
              class="content-list showCard-list"
              v-for="(item, index) in trainingCatalogueList"
              :key="index"
              @click="onImageTagging(item)"
            >
              <span
                v-if="!teacherOrStudentState"
                :class="[
                  'state-student',
                  item.isComplete == 1 ? 'icon-completed' : 'icon-no-completed',
                ]"
              ></span>
              <div class="content-list-img">
                {{ index + 1 }}
              </div>
              <div class="content-list-card">
                <div class="card-title">
                  <span>{{ item.trainingName }}</span>
                  <span v-if="item.type == 1" class="sign programming-bg-color">编程</span>
                  <span v-else-if="item.type == 2" class="sign hardware-bg-color">硬件</span>
                  <span v-else-if="item.type == 3" class="sign data-bg-color">数据</span>
                  <span v-else class="sign industry-bg-color">行业</span>
                  <!-- 编辑、删除 -->
                  <div class="edit-delete" v-if="roleCoursePermissions() && getEditorTypeName(item.editorType)">
                    <span
                      title="复制"
                      class="icon-copy"
                      @click.stop="activeCopyPopup(item)"
                    ></span>
                    <i class="int"></i>
                    <span
                      title="编辑"
                      class="edit-icon"
                      @click.stop="activeEditePopup(item)"
                    ></span>
                    <i class="int"></i>
                    <span
                      title="删除"
                      class="delete-icon"
                      @click.stop="activeDeletePopup(item)"
                    ></span>
                  </div>
                </div>
                <div class="card-content-and"> 
                  <div class="card-content" :title="item.trainingContent">{{ item.trainingContent }}</div>
                  <!-- <tooltip-box
                    class="card-content"
                    :textRef="'curriculumContent'"
                    :textId="item.curriculumId"
                    :textRow="3"
                    :textName="item.curriculumContent"
                    :placement="'bottom'"
                    :tooltipShow="false"
                  ></tooltip-box> -->
                  <!-- modifyCoverObj.type = 0 为精课程实训才可发布作业 -->
                  <div v-if="getEditorTypeName(item.editorType) && modifyCoverObj.type == 0">
                    <div class="card-content-state" v-if="userRole == 1 || userRole == 3">
                      <span :class="['state-text', {'state-text-red': !(item.status != 0)}]">
                        {{ item | trainingStatusText }}
                      </span>
                      <span class="int"></span>
                      <span
                        v-if="item.status == 2"
                        class="state-text state-text-grey"
                        @click.stop="onReleaseTraining(item, 3)"
                        >撤回发布</span
                      >
                      <span
                        v-else
                        class="state-text"
                        @click.stop="onReleaseTraining(item, 2)"
                        >发布</span
                      >
                      <span class="int"></span>
                      <span :class="['state-text', teacherOrStudentState && item.status === 2 && item.studentHomework ? 'state-text-task':'']" @click.stop="onTask(item)">
                        <i>作业</i>
                        <i v-if="teacherOrStudentState && item.status === 2">{{ item.studentHomework }}</i>
                      </span>
                    </div>
                    <div class="card-content-state" v-if="userRole == 2">
                      <span class="state-text state-text-studentOne">
                        <i class="icon-code"></i>
                      </span>
                      <span
                        class="state-text state-text-studentTwo"
                      >
                        {{item.score !== null ? item.score : '未评分'}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="card-number">
                  <span class="card-number-one">
                    <span :class="['icon', getEditorTypeClassName(item.dictTypeDesc)]"></span>
                    <!-- {{ getEditorTypeName(item.editorType) }} -->
                    {{ item.dictTypeDesc }}
                  </span>
                  <span class="card-number-two">
                    <span class="icons el-icon-time"></span>{{ item.updateTime }}
                  </span>
                </div>
              </div>
            </div>

            <div
              class="content-list-addTraining"
              v-if="roleCoursePermissions()"
              @click="activeCreatePopup"
            >
              <span class="addIcon el-icon-circle-plus-outline"></span>
              <span>添加实训项目</span>
            </div>
          </div>

          <!-- 关联租户 -->
          <associated-tenant v-if="navSelectName === '关联租户'" :curriculumId="curriculumId" @getTableData="getTableData"></associated-tenant>

          <!-- 关联用户 -->
          <associated-users v-if="navSelectName === '关联用户'" :curriculumId="curriculumId" @getTableData="getTableData"></associated-users>
        </div>
        
        <!-- 分页 -->
        <!-- <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="10"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="totalCount"
          ></el-pagination>
        </div> -->
      </div>
    </div>
    <div class="popup-list">
      <!-- 新建项目 | 编辑项目 -->
      <gat-popup
        :class="[
          'popup-create',
          /(create|edit)/.test(popupActive) ? 'on' : 'off',
        ]"
        :title="popup.title[popupActive]"
        :primary-button="popup.btnTxt[popupActive]"
        @cancel="cancelPopup"
        @confirm="projectEdite"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewProject"
            :rules="rules"
            ref="popupUploadForm"
          >
            <el-form-item prop="ProjectName">
              <el-input
                placeholder="项目名称，必填项"
                v-model.trim="NewProject.ProjectName"
                maxlength="25"
                show-word-limit
              />
            </el-form-item>
            <el-form-item prop="ProjectType">
              <el-select
                class="pop-select"
                v-model="NewProject.ProjectType"
                placeholder="请选择项目类型，必填项"
                @change="changeProjectType"
                :disabled="popupActive === 'edit' ? true : false"
                filterable
              >
                <el-option
                  v-for="item in projectTypeArr"
                  :key="item.projectType"
                  :label="item.dictTypeDesc"
                  :value="item.projectType"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="eidtorType">
              <el-select
                class="pop-select"
                v-model="NewProject.eidtorType"
                placeholder="请选择编辑方式，必填项"
                :disabled="popupActive === 'edit' ? true : false"
                filterable
              >
                <el-option
                  v-for="item in editorTypesArr"
                  :key="item.dictId"
                  :label="item.dictTypeDesc"
                  :value="item.dictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="quoteTrainingId" v-if="trainingModelShow">
              <el-select
                class="pop-select"
                v-model="NewProject.quoteTrainingId"
                placeholder="引用标注实训应用项目模型（非必选）"
                :disabled="popupActive === 'edit' ? true : false"
                filterable
              >
                <el-option
                  v-for="item in projectModelArr"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="ProjectContent">
              <el-input
                class="pop-textarea"
                type="textarea"
                :rows="5"
                maxlength="200"
                placeholder="项目描述，必填项"
                v-model.trim="NewProject.ProjectContent"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">确定删除该实训项目吗？</span>
            </div>

            <div class="content">
              {{quoteModelNum != 0 ? `该实训项目已被${quoteModelNum}个项目引用，删除后可在“回收站”恢复哦！`:'删除后可在“回收站”恢复哦！'}}
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 复制课程名称弹窗 -->
      <gat-popup
        :class="[
          'popup-create-copy', popupActive === 'copyTraining' ? 'on' : 'off',
        ]"
        :title="'复制实训'"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="copyProject"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="newCopyTraining"
            :rules="rulesCopyTraining"
            ref="popupCopyTraining"
          >
            <el-form-item prop="copyTrainingName">
              <div class="intxt">
                <span class="label"><i class="required">*</i>实训名称：</span>
                <el-input
                  placeholder="请输入实训名称，必填项"
                  v-model.trim="newCopyTraining.copyTrainingName"
                  maxlength="25"
                  show-word-limit
                />
              </div>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>
    </div>
    <guide-tool path="training-center"></guide-tool>
  </div>
</template>

<script>
import COMMON from '@/axios/common/common.js'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'

import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import SearchBox from '@/components/common/SearchBox.vue'
// import TooltipBox from '@/components/common/TooltipBox'
import AssociatedTenant from '@/views/trainingCenter/components/associatedTenant.vue'
import AssociatedUsers from '@/views/trainingCenter/components/associatedUsers.vue'
import GuideTool from '@/components/guide/GuideTool.vue'

import { mapGetters } from 'vuex'
import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: 'CourseDetails',
  mixins: [GetVerifyImgs],
  //import引入的组件需要注入到对象中才能使用
  components: {
    GatPopup,
    IconInfoHelp,
    SearchBox,
    // TooltipBox,
    AssociatedTenant,
    AssociatedUsers,
    GuideTool
    },
  data() {
    return {
      userRole: 2, // 角色： 1-老师、2-学生、3-校管理员、4-超级管理员
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      navSelectName: '实训目录',
      modifyCoverObjAll: {},
      modifyCoverObj: {
        curriculumName: '',
        curriculumContent: '',
        imgUrl: '',
      }, // 课程信息
      curriculumId: '', // 课程Id
      searchKey: '', // 搜索关键词
      selectIconSort: null, // 当前选中的排序 0：创建时间；1：更新时间；2：项目名称
      selectIconSortState: null, // 当前选中的升降序状态 0：升序；1：降序
      sortList: [
        {
          sortName: '名称',
          sortType: 2,
          sortTop: 0,
          sortBottom: 1,
        },
        {
          sortName: '标签',
          sortType: 3,
          sortTop: 0,
          sortBottom: 1,
        },
        {
          sortName: '添加日期',
          sortType: 0,
          sortTop: 0,
          sortBottom: 1,
        },
        {
          sortName: '修改日期',
          sortType: 1,
          sortTop: 0,
          sortBottom: 1,
        },
      ],
      teacherOrStudentState: true, // 老师或学生状态；true时是除学生外的任何角色 false为学生
      trainingCatalogueList: [],
      traningTypes: [], //实训编辑类型
      editorTypesArr: [], //实训编辑类型的子集：编辑器类型
      projectTypeArr: [],
      projectModelArr: [], // 实训模型项目
      NewProject: {
        trainingId: '',
        ProjectName: '',
        ProjectContent: '',
        ProjectType: null,
        eidtorType: '',
        quoteTrainingId: '',
      },
      rules: {
        ProjectName: [{ required: true, message: '请填写项目名称' }],
        ProjectContent: [{ required: true, message: '请输入项目描述内容' }],
        ProjectType: [{ required: true, message: '请选择项目类型' }],
        eidtorType: [{ required: true, message: '请选择编辑方式' }],
      },
      trainingModelShow: false,
      popupActive: '',
      popup: {
        title: {
          edit: '编辑实训项目',
          create: '添加实训项目',
        },
        btnTxt: {
          edit: '确定',
          create: '添加',
        },
      },
      copyTraining: {},
      newCopyTraining: {
        copyTrainingName: '',
      },
      rulesCopyTraining: {
        copyTrainingName: [{ required: true, message: '请输入实训名称' }],
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      totalCount: 0,
      currentPage: 1,
      tableData: [],
      quoteModelNum: 0, // 引用实训模型次数
      // profile: require('../../../public/images/profile03.png'),
      fullscreenLoading: null, // 加载效果
    }
  },
  filters: {
    // 实训项目状态处理
    trainingStatusText(value) {
      let statusText = '';
      if (value.type == 3) { // 实训模型
        statusText = value.status != 0 ? '已发布模型' : '未发布模型'
      } else { // 实训积木
        statusText = value.status != 0 ? '已提交代码' : '未提交代码'
      }
      return statusText;
    },
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['editorTypeList']),
  },
  //监控data中的数据变化
  watch: {
    modifyCoverObj(val) {
      this.modifyCoverObj.curriculumName = val.curriculumName;
      this.modifyCoverObj.curriculumContent = val.curriculumContent;
      this.modifyCoverObj.imgUrl = val.imgUrl;
    },
    trainingCatalogueList: {
      handler() {
        // 根据实训课程id查询实训模型项目
        this.getTagTrainingByCurriculumId();
      },
      deep: true,
      immediate: true,
    },
    'NewProject.eidtorType'(val) {
      this.trainingModelShow = false;
      if (val) {
        this.editorTypesArr.forEach(item => {
          if (item.dictId === val && item.dictTypeDesc.indexOf('积木模式') !== -1) {
            this.trainingModelShow = true;
          }
        });
      }
    }
  },
  created() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {
    this.$refs.gatHead.getHasLogin(); // 调用头部组件登录信息刷新头部导航栏
    this.navSelectName = '实训目录';
    this.userRole = this.$store.state.userRole;
    this.curriculumId = this.$route.query.curriculumId;
    // 获取课程信息
    this.getCurriculumInfoByCurriculumId();
    // 获取实训列表
    this.getTrainingListByCurriculumList(1);
    // 获取编辑器类型列表
    this.getTrainingTypeApi();
    // 根据租户查询实训项目类型
    this.getProjectType();

    let trainingId = this.$route.query.trainingId || '';
    this.trainingProjectPositioning(trainingId); // 根据实训项目id定位

    this.cancelPopup(); // 默认关闭弹窗
  },
  // 如果页面有keep-alive缓存功能,退出触发
  deactivated() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getTrainingTypeApi();
  },
  methods: {
    // 根据实训项目id定位
    trainingProjectPositioning(id) {
      if (id) {
        setTimeout(function () {
          var div = document.getElementById(id);
          //跳转到id位置
          div.scrollIntoView({
            block: 'center',
            behavior: 'auto',
            inline: 'start',
          })
        }, 500);
      }
    },
    // 内置课程&&角色-权限处理
    roleCoursePermissions() {
      if (this.modifyCoverObj.type == 1) { // 内置课程
        return this.userRole == 4 ? true : false // 4-超级管理员
      } else {  // 精品课程
        return this.userRole == 2 ? false : true // 2-学生
      }
    },
    getTrainingListByCurriculumList(pageIdx) {
      if (this.userRole == 2) {
        this.teacherOrStudentState = false
        this.getTrainingListByCurriculumIdStu(pageIdx)
      } else {
        this.teacherOrStudentState = true
        this.getTrainingListByCurriculumId(pageIdx)
      }
    },
    // 检验当前租户是否拥有编辑器类型的权限
    getEditorTypeName(editorTypeId) {
      let text = ''
      this.traningTypes.forEach(item => {
        if (item.dictId === editorTypeId) {
          text = item.dictTypeDesc
        }
      });
      return text
    },
    getEditorTypeClassName(editorType) {
      let className = ''
      if (/积木/i.test(editorType)) {
        className = 'icon_Block-Editor'
      } else if (/代码/i.test(editorType)) {
        className = 'icon_Code-Editor'
      } else if (/海龟/i.test(editorType)) {
        className = 'icon_Turtle-bank'
      } else if (/小智/i.test(editorType)) {
        className = 'icon_Little-Wisdom-Editor'
      } else if (
        editorType == '图像分类' 
        || editorType == '物体检测' 
        || editorType == '文本分类'
        || editorType == '文本标注'
        || editorType == '音频分类'
        || editorType == '音频标注'
      ) {
        className = 'icon_Data-Annotations'
      }
      return className
    },
    // 根据租户查询实训项目类型
    getProjectType() {
      let data = {
        dictTypeCode: 'ItemType', // 字典编码
      }
      PROJECTS.getProjectType(data).then((result) => {
        if (result && result.isSuccess) {
          this.projectTypeArr = result.data
        }
      })
    },
    // 根据实训课程id查询实训模型项目
    getTagTrainingByCurriculumId() {
      let data = {
        curriculumId: this.curriculumId, // 课程id
      }
      PROJECTS.getTagTrainingByCurriculumId(data).then((result) => {
        if (result.isSuccess) {
          this.projectModelArr = result.data
        }
      })
    },
    // 发布/撤回发布
    onReleaseTraining(item, status) {
      if (item.status == 0) {
        let msg = item.type == 3 ? '请先发布模型！' : '请先提交代码！';
        return this.$message.error(msg);
      }

      let params = {
        type: item.type, // 实训项目类型
        status: status, // 实训状态
        trainingId: item.trainingId, // 实训id
      };
      if (item.type == 3) {
        params.editorType = item.editorType;
      }

      PROJECTS.releaseTraining(params).then((result) => {
        if (result.returnCode === 200) {
          if (status === 2) {
            this.$message.success('发布成功！');
          } else {
            this.$message.success('撤回成功！');
          }
          this.getTrainingListByCurriculumList();
        }
      })
    },
    // 创建新任务、数据标注
    onImageTagging(item) {
      let editorType = this.getEditorTypeName(item.editorType)
      if (!editorType) {
        return this.$message({
          message: `当前系统版本未配置${item.dictTypeDesc}模块，如需升级请联系超级管理员哦！`,
          type: 'warning',
          duration: 3000,
        })
      }
      if (this.modifyCoverObj.type == 1 && this.userRole != 4) { // 内置课程&&不是超级管理员 不往下执行
        return this.$message({
          message: `您没有内置课程项目编辑权限哦，请先复制该课程再查看编辑吧~`,
          type: 'warning',
          duration: 3000,
        })
      }

      this.$router.push({ query: {curriculumId: this.curriculumId} }); // 跳转页面前 重置原来参数，避免后退复位偏差
      
      if (item.type === 3) {
        // 数据标注
        if (item.status === 2 && this.teacherOrStudentState) { // 老师查看实训详情
          this.$router.push({
            name: 'training-model',
            query: {
              trainingId: item.trainingId,
              modelType: item.editorType,
            },
          })
        } else {
          this.$router.push({ // 学生查看实训详情
            name: 'training-model',
            query: {
              curriculumId: item.curriculumId,
              trainingId: item.trainingId,
              userId: item.createBy,
              modelType: item.editorType
            },
          })
        }
      } else {
        // 创建新任务
        this.redirectToProject(item)
      }
    },
    //实训-重定向到不同类别的编辑器
    redirectToProject(project) {
      let dictTypeDesc, queryName
      this.traningTypes.forEach((item) => {
        if (item.dictId == project.editorType) {
          dictTypeDesc = item.dictTypeDesc
        }
      })
      // console.log('dictTypeDesc',dictTypeDesc)
      if (/(?=.*AI-T).*(?=.积木模式)/i.test(dictTypeDesc)) {
        queryName = 'training-editor-block'
      } else if (/AI-T/i.test(dictTypeDesc)) {
        queryName = 'training-editor-ai-python'
      } else if (/海龟|基础/i.test(dictTypeDesc)) {
        queryName = 'training-editor-baseBlock'
      }
      this.$router.push({
        name: queryName,
        query: {
          trainingId: project.trainingId,
          trainingName: project.trainingName,
          type: project.type,
          createBy: project.createBy,
          curriculumId: project.curriculumId,
          editorType: project.editorType,
          quoteTrainingId: project.quoteTrainingId,
        },
      })
    },
    // 作业
    onTask(item) {
      this.$router.push({
        name: 'publish-list',
        query: {
          curriculumId: item.curriculumId,
          trainingId: item.trainingId,
          type: item.type,
          editorType: item.editorType,
          quoteTrainingId: item.quoteTrainingId,
        },
      })
    },
    // 点击新建项目弹窗
    activeCreatePopup() {
      // 根据实训课程id查询实训模型项目
      this.getTagTrainingByCurriculumId();
      this.popupActive = 'create';
    },
    // 上传图片
    uploadPictures() {
      var uploadFileNode = document.createElement('input') // 创建上传按钮
      var fileList = [] // 文件列表
      var self = this

      uploadFileNode.setAttribute('type', 'file') // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture') // 多文件上传
      uploadFileNode.setAttribute("accept", "image/jpeg,image/jpg"); // 限制选择图片格式
      // uploadFileNode.setAttribute('accept', 'image/*') // 限制图片上传
      // uploadFileNode.setAttribute("enctype", "multipart/form-data;"); // 编码方式

      uploadFileNode.click() // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          list,
          formatPass = true

        // 文件装配
        fileList = evt.target.files
        list = Array.from(fileList)

        // 如果存在不是 image/jpeg 格式的图片就会触发停止上传的操作
        // jpg/jpeg 是一样，同属于 image/jpeg 格式
        formatPass = self.$util.filesFormatCheck(list, 'jpg|jpeg')

        if (formatPass) {
          return self.$message.error('上传失败，只允许上传 jpg/jpeg 格式图片！')
        }

        list.forEach((file) => {
          formdata.append('file', file, file.name)
        })

        let fullscreenLoading = self.$loading({
          lock: true,
          text: `图片上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        COMMON.UploadMultipleFile(formdata).then((result) => {
          if (result.returnCode == 200) {
            let imgList = result.data;
            if (imgList.length === 0) {
              return fullscreenLoading.close(); // 关闭Loading
            }
            // 校验图片jpg|jpeg
            self.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                if (imgList[0].url) {
                  self.modifyCoverObj.imgUrl = imgList[0].url
                  self.updateCurriculum()
                }
              }
            })
            fullscreenLoading.close(); // 关闭Loading
          } else {
            fullscreenLoading.close(); // 关闭Loading
          }
        }).catch(err => {
          console.log('error', err)
          fullscreenLoading.close(); // 关闭Loading
        });
      }
    },

    // 根据课程实训id查询实训信息
    getCurriculumInfoByCurriculumId() {
      let params = {
        curriculumId: this.curriculumId,
      }
      PROJECTS.getCurriculumInfoByCurriculumId(params).then((result) => {
        // console.log('根据课程ID获取课程信息', result)
        if (result.returnCode === 200) {
          if (result.data) {
            this.modifyCoverObjAll = JSON.parse(JSON.stringify(result.data))
            this.modifyCoverObj = result.data
          }
        }
      })
    },
    // 修改修改课程信息
    updateCurriculum() {
      let modifyCoverObjAll = this.modifyCoverObjAll
      let modifyCoverObj = this.modifyCoverObj
      if (
        modifyCoverObjAll.curriculumContent === modifyCoverObj.curriculumContent &&
        modifyCoverObjAll.curriculumName === modifyCoverObj.curriculumName &&
        modifyCoverObjAll.imgUrl === modifyCoverObj.imgUrl
      ) {
        return
      }
      if (!modifyCoverObj.curriculumName) {
        return this.$message.error('请输入课程标题！')
      }
      if (!modifyCoverObj.curriculumContent) {
        return this.$message.error('请输入课程简介！')
      }
      let params = {
        curriculumContent: this.modifyCoverObj.curriculumContent,
        curriculumName: this.modifyCoverObj.curriculumName,
        curriculumId: this.modifyCoverObj.curriculumId, // 课程id
        imgUrl: this.modifyCoverObj.imgUrl,
      }

      PROJECTS.updateCurriculum(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success('修改课程成功！')
          this.getCurriculumInfoByCurriculumId()
        } else if (result.errorCode === 40101) {
          // 项目名称重复，重新输入名称。
          this.$message.error('课程名称重复，请重新输入课程名称！')
        }
      })
    },
    // 获取老师实训列表
    getTrainingListByCurriculumId(pageIdx) {
      let params = {
        curriculumId: this.curriculumId,
        pageNum: 1,
        pageSize: 999,
        sort: this.selectIconSort === null ? 1 : this.selectIconSort, // 0:创建时间； 1:更新时间； 2:名称；
        sortRule: this.selectIconSortState === null ? 1 : this.selectIconSortState, //  0升序；1降序
        trainingName: this.searchKey || '',
      }
      PROJECTS.getTrainingListByCurriculumId(params).then((result) => {
        // console.log('根据课程ID获取实训列表(老师)', result)
        if (result.returnCode === 200) {
          this.totalCount = result.data.total || 0
          this.trainingCatalogueList = result.data.records || []
          let recordsList = result.data.records || []
          recordsList.forEach(async (item, index) => {
            if (item.status === 2) {
              // 获取学生提交作业
              let data = {
                isSubmit: 1, // 是否提交 1-已提交，0-未提交
                pageNum: 1, // 当前页数
                pageSize: 10, // 每页条数
                trainingId: item.trainingId, // 实训id
              }
              let result = await MARKCENTER.getTaskByTrainingId(data)
              if (result.returnCode === 200 && result.data) {
                this.$set(
                  this.trainingCatalogueList[index],
                  'studentHomework',
                  result.data.total
                )
              }
            }
          })
        }
      })
    },
    // 获取学生实训列表
    getTrainingListByCurriculumIdStu(pageIdx) {
      let params = {
        curriculumId: this.curriculumId,
        pageNum: 1,
        pageSize: 999,
        sort: this.selectIconSort === null ? 1 : this.selectIconSort, // 0:创建时间； 1:更新时间； 2:名称；
        sortRule:
          this.selectIconSortState === null ? 1 : this.selectIconSortState, //  0升序；1降序
        trainingName: this.searchKey || '',
      }
      PROJECTS.getTrainingListByCurriculumIdStu(params).then((result) => {
        // console.log('根据课程ID获取实训列表(学生)', result)
        if (result.returnCode === 200) {
          this.totalCount = result.data.total || 0
          this.trainingCatalogueList = result.data.records || []
        }
      })
    },
    // 新建项目
    createNewProject() {
      // 项目命名不能为空和超出限制的字符长度
      if (
        this.$util.checkStrNullOrTooLong.call(this, [
          this.NewProject.ProjectName,
        ])
      ) {
        return
      }

      let params = {
        curriculumId: this.curriculumId,
        trainingName: this.NewProject.ProjectName,
        trainingContent: this.NewProject.ProjectContent,
        type: this.NewProject.ProjectType,
        editorType: this.NewProject.eidtorType,
        quoteTrainingId: '', // 引用实训模型项目id
      }
      if (this.trainingModelShow) {
        params.quoteTrainingId = this.NewProject.quoteTrainingId
      }

      PROJECTS.insertTraining(params).then((result) => {
        if (result.isSuccess) {
          // 点击【马上创作】进来
          if (
            this.$route.query.operate === 'create' &&
            this.isRedirectToTraining
          ) {
            this.redirectToTraining(result.data.ProjectId)
          } else {
            this.$message.success('项目添加成功！')
            // this.GetPageListByName(1);
            this.getTrainingListByCurriculumList()
            this.cancelPopup()
            let trainingId = result.data && result.data.trainingId || ''
            this.trainingProjectPositioning(trainingId) // 根据实训项目id定位
          }
        } else if (result.ErrorCode === 40101) {
          // 项目名称重复，重新输入名称。
          this.$message.error('项目名称重复，请重新输入名称！')
        } else {
          this.$message.error(result.returnMsg)
        }
      })
    },

    // 选择数据类型、编辑器类型
    changeProjectType(val) {
      this.NewProject.eidtorType = ''
      let arr = this.projectTypeArr.filter((item) => item.projectType == val)
      if (!arr || arr.length == 0) return
      let label = arr[0].dictTypeDesc
      if (label == '数据标注应用') {
        this.editorTypesArr = this.traningTypes.filter(item=>/ModelType/.test(item.dictTypeCode))
      } else {
        this.editorTypesArr = this.traningTypes.filter(item=>/编辑器/.test(item.dictContent) &&!/小智|小聪/.test(item.dictTypeDesc))
        // this.editorTypesArr = this.traningTypes.filter(item=>/EditorType/.test(item.dictTypeCode) && !/小智|小聪/.test(item.dictTypeDesc))
      }
    },

    // 复制实训
    activeCopyPopup(val) {
      this.popupActive = 'copyTraining'
      this.copyTraining = val
      this.newCopyTraining.copyTrainingName = val.trainingName
    },
    // 确认复制实训
    copyProject() {
      this.$refs.popupCopyTraining.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '复制中请稍等...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
          })
          setTimeout(() => {
            loading.close();
          }, 1000 * 30)
    
          let params = {
            // type: this.copyTraining.editorType,
            curriculumId: this.copyTraining.curriculumId, // 实训id
            trainingId: this.copyTraining.trainingId, // 实训id
            trainingName: this.newCopyTraining.copyTrainingName,
          }
          PROJECTS.copyTraining(params).then((result) => {
            if (result.isSuccess) {
              this.getTrainingListByCurriculumList(1);
              this.cancelPopup();
              this.$message.success(result.returnMsg);
              loading.close();
            } else {
              this.$message.error(result.returnMsg);
              loading.close();
            }
          }).catch(() => {
            loading.close();
          })
        }
      })
    },

    // 编辑项目，创建项目 + 编辑项目
    projectEdite() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (this.popupActive === 'create') {
            // 新增
            this.createNewProject()
          } else if (this.popupActive === 'edit') {
            // 编辑
            this.editeProject()
          }
        }
      })
    },
    // 编辑
    activeEditePopup(item) {
      // this.NewProject = item;
      this.NewProject.ProjectName = item.trainingName;
      this.NewProject.ProjectContent = item.trainingContent;
      this.NewProject.ProjectType = item.type;
      this.NewProject.eidtorType = item.editorType;
      this.NewProject.id = item.trainingId;
      this.editorTypesArr = this.traningTypes; // 由于添加数据类型处理，将类型列表赋值编辑选择列表，避免展示问题
      this.NewProject.quoteTrainingId = item.quoteTrainingId || '';
      this.popupActive = 'edit';

      this.projectModelArr = [];
      if (item.quoteTrainingId) {
        this.projectModelArr = [{
          value: item.quoteTrainingId,
          text: item.quoteTrainingName,
        }];
      };
    },
    // 编辑项目
    editeProject() {
      // let index = this.getProjectIndexByIdLocal(this.NewProject.ProjectId);

      // 项目命名不能为空和超出限制的字符长度
      if (
        this.$util.checkStrNullOrTooLong.call(this, [
          this.NewProject.ProjectName,
        ])
      ) {
        return
      }

      let params = {
        trainingContent: this.NewProject.ProjectContent,
        trainingName: this.NewProject.ProjectName,
        trainingId: this.NewProject.id,
        type: this.NewProject.ProjectType,
      }

      PROJECTS.updateTraining(params).then((result) => {
        if (result.isSuccess) {
          this.$message.success('成功编辑项目！')
          this.getTrainingListByCurriculumList()
          this.cancelPopup()
        } else {
          // 项目名称重复，重新输入名称。
          this.$message({
            message: result.returnMsg || '项目名称重复，请重新输入名称',
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 删除
    activeDeletePopup(item) {
      this.quoteModelNum = 0; // 默认初始删除提示
      if (item.type == 3) {
        this.getQuoteCountByTrainingId(item.trainingId);
      }
      this.activeProject = item;
      this.popupActive = 'delete';
    },
    // 查询实训项目被引用的实训模型
    getQuoteCountByTrainingId(trainingId) {
      let data = {
        trainingId: trainingId
      }
      PROJECTS.getQuoteCountByTrainingId(data).then((result) => {
        if (result.isSuccess) {
          this.quoteModelNum = result.data;
        }
      })
    },
    // 删除实训项目
    deleteProject() {
      let params = {
        trainingContent: this.activeProject.trainingContent,
        trainingId: this.activeProject.trainingId,
        trainingName: this.activeProject.trainingName,
      }
      PROJECTS.deleteTraining(params).then((result) => {
        if (result.isSuccess) {
          // this.Project.Items.splice(activeProjectIndex, 1);
          this.$message.success('删除成功！');
          this.getTrainingListByCurriculumList();
          this.cancelPopup();
        }
      })
    },
    // 取消弹窗
    cancelPopup() {
      if (/(create|edit)/.test(this.popupActive)) {
        this.NewProject = {
          ProjectId: '0',
          ProjectName: '',
          // BlocksFileUrl: "",
          ProjectContent: '',
          ProType: '',
          ProTypeName: '',
          eidtorType : '',
        }

        this.$refs.popupUploadForm.resetFields()
      }

      if (this.popupActive === 'copyTraining') {
        this.newCopyTraining.copyTrainingName = ''
        this.$refs.popupCopyTraining.resetFields()
      }

      this.popupActive = ''
    },
    // 分页
    handleCurrentChange(pageIdx) {
      this.currentPage = pageIdx
      this.getTrainingListByCurriculumList(pageIdx)
    },
    // 名称排序
    onIconSortName(selectIconSort) {
      if (this.selectIconSort == selectIconSort && this.selectIconSortState == 0) {
        this.selectIconSort = selectIconSort
        this.selectIconSortState = 1
      } else {
        this.selectIconSort = selectIconSort
        this.selectIconSortState = 0
      }
      this.getTrainingListByCurriculumList(1) // 获取实训列表
    },
    // 排序
    onIconSort(selectIconSort, selectIconSortState) {
      this.selectIconSort = selectIconSort
      this.selectIconSortState = selectIconSortState
      this.getTrainingListByCurriculumList(1) // 获取实训列表
    },
    // 搜索获取项目分页
    GetPageListByName(key) {
      this.searchKey = key
      this.getTrainingListByCurriculumList(1) // 获取实训列表
    },
    // 查询实训项目编辑方式
    getTrainingTypeApi() {
      let data = {
        dictTypeCode: 'EditorType',
      }
      return PROJECTS.getTrainingType(data).then((res) => {
        if (res && res.returnCode == 200) {
          this.traningTypes = res.data
        }
      }).catch((err) => {
        console.log(err)
      })
    },

    // 获取已关联租户/用户列表总数
    getTableData(val) {
      this.tableData = val ? val : []
    }

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  // activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './CourseDetails';
.el-icon-top {
  color: #000;
  position: fixed;
  bottom: 50px;
  right: 50px;
  z-index: 9999;
}
</style>
